module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"assets":"Activos","liabilities":"Pasivos","equity":"Patrimonio","difference":"Diferencia"},"pe":{"assets":"Activos","liabilities":"Pasivos","equity":"Patrimonio","difference":"Diferencia"}}')
  delete Component.options._Ctor
}
